import { render } from "./InspectionResultDetail.vue?vue&type=template&id=76997de8"
import script from "./InspectionResultDetail.vue?vue&type=script&lang=js"
export * from "./InspectionResultDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__